import liveViewApi from './liveView'
import channelManagementApi from './channelManagement'
import recordApi from './record'
import { setURL } from '@/api/apiUtil'

export default {
  // 即時影像
  ...liveViewApi,
  // 攝影機管理
  ...channelManagementApi,
  // 下載影像
  ...recordApi,
  // 列出社區底下 搜尋NVR Cam 裝置
  getNvrDeviceList: {
    url: '/WebAPI/api/Device/list',
    method: 'get'
  },
  // 時間選項的搜尋列不能用setURL，空值會出錯

}
